// extracted by mini-css-extract-plugin
export default {"invoice":"InvoicePreview_invoice__qalHY"};